import { uuid, varchar } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { index, uniqueIndex } from 'drizzle-orm/pg-core/indexes';
import { foreignKey } from 'drizzle-orm/pg-core/foreign-keys';
import { companies } from './companies';
import { shareTransactions } from './initial';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel } from 'drizzle-orm/table';
import { identities } from './identities';
import { commonFields } from './common-fields';
import { warrantShareholders } from './warrant_programs';

export type Shareholder = InferSelectModel<typeof shareholders>;

export const shareholders = pgTable(
  'shareholders',
  {
    ...commonFields,
    companyId: uuid().notNull(),
    email: varchar(),
    ownerCompanyId: uuid(),
    identityId: uuid().notNull(),
  },
  table => {
    return [
      {
        idxShCidIid: uniqueIndex('idx_sh_cid_iid').using(
          'btree',
          table.companyId.asc().nullsLast().op('uuid_ops'),
          table.identityId.asc().nullsLast().op('uuid_ops'),
        ),
        idxShareholdersCidOcid: index('idx_shareholders_cid_ocid').using(
          'btree',
          table.companyId.asc().nullsLast().op('uuid_ops'),
          table.ownerCompanyId.asc().nullsLast().op('uuid_ops'),
        ),
        idxShareholdersCompanyId: index('idx_shareholders_company_id').using(
          'btree',
          table.companyId.asc().nullsLast().op('uuid_ops'),
        ),
        idxShareholdersIdentityId: index('idx_shareholders_identity_id').using(
          'btree',
          table.identityId.asc().nullsLast().op('uuid_ops'),
        ),
        shareholdersCompanyIdFkey: foreignKey({
          columns: [table.companyId],
          foreignColumns: [companies.id],
          name: 'shareholders_company_id_fkey',
        }),
        shareholdersIdentityIdFkey: foreignKey({
          columns: [table.identityId],
          foreignColumns: [identities.id],
          name: 'shareholders_identity_id_fkey',
        }),
        shareholdersOwnerCompanyIdFkey: foreignKey({
          columns: [table.ownerCompanyId],
          foreignColumns: [companies.id],
          name: 'shareholders_owner_company_id_fkey',
        }),
      },
    ];
  },
);

export const shareholdersRelations = relations(shareholders, ({ one, many }) => ({
  shareTransactions_buyerId: many(shareTransactions, {
    relationName: 'shareTransactions_buyerId_shareholders_id',
  }),
  shareTransactions_sellerId: many(shareTransactions, {
    relationName: 'shareTransactions_sellerId_shareholders_id',
  }),
  company_companyId: one(companies, {
    fields: [shareholders.companyId],
    references: [companies.id],
    relationName: 'shareholders_companyId_companies_id',
  }),
  identity: one(identities, {
    fields: [shareholders.identityId],
    references: [identities.id],
  }),
  company_ownerCompanyId: one(companies, {
    fields: [shareholders.ownerCompanyId],
    references: [companies.id],
    relationName: 'shareholders_ownerCompanyId_companies_id',
  }),
  warrantShareholders: many(warrantShareholders),
}));
